<template>
    <div class="el-main-wrapper">
        <el-row class="el-title-block">
            <h1 class="el-title-with-icon">
                {{ $t('title.dashboard') }}
            </h1>
            <h2 class="el-sub-title">
                {{ $t('title.sub.dashboard') }}
            </h2>
        </el-row>

        <el-row class="el-dashboard-card-wrapper">
            <router-link
                v-if="!isBlc && permissions.includes('ACTOR_READ')"
                :to="{ name: 'bookings' }"
                class="el-dashboard-card el-dashboard-card-booking"
            >
                <div class="el-card-title">
                    <span>{{ $t('text.manage') }}</span>
                    {{ $t('navigation.bookings') }}
                </div>
            </router-link>
            <router-link
                v-if="permissions.includes('USER_READ')"
                :to="{ name: 'userTool' }"
                class="el-dashboard-card el-dashboard-card-userTool"
            >
                <div class="el-card-title">
                    <span>{{ $t('text.manage') }}</span>
                    {{ $t('navigation.userTool') }}
                </div>
            </router-link>
            <router-link
                v-if="permissions.includes('USER_READ')"
                :to="{ name: 'userGroups' }"
                class="el-dashboard-card el-dashboard-card-users"
            >
                <div class="el-card-title">
                    <span>{{ $t('text.manage') }}</span>
                    {{ $t('navigation.userGroups') }}
                </div>
            </router-link>
            <router-link
                v-if="permissions.includes('CHECKPOINT_READ')"
                :to="{ name: 'gates' }"
                class="el-dashboard-card el-dashboard-card-checkpoints"
            >
                <div class="el-card-title">
                    <span>{{ $t('text.manage') }}</span>
                    {{ $t('navigation.checkpoints') }}
                </div>
            </router-link>
            <router-link
                v-if="permissions.includes('UNLOADINGAREA_READ')"
                :to="{ name: 'unloading-areas' }"
                class="el-dashboard-card el-dashboard-card-unloading"
            >
                <div class="el-card-title">
                    <span>{{ $t('text.manage') }}</span>
                    {{ $t('navigation.unloadingAreas') }}
                </div>
            </router-link>
            <router-link
                v-if="isBlc"
                :to="{ name: 'blc/material-manager' }"
                class="el-dashboard-card el-dashboard-card-material-manager"
            >
                <div class="el-card-title">
                    <!--                    <span>{{ $t('text.manage') }}</span>-->
                    {{ $t('navigation.materialManager') }}
                </div>
            </router-link>
            <router-link
                v-if="isBlc"
                :to="{ name: 'blc/route-planner' }"
                class="el-dashboard-card el-dashboard-card-route-planner"
            >
                <div class="el-card-title">
                    <!--                    <span>{{ $t('text.manage') }}</span>-->
                    {{ $t('navigation.routePlanner') }}
                </div>
            </router-link>
            <router-link
                v-if="isBlc"
                :to="{ name: 'blc/follow-up' }"
                class="el-dashboard-card el-dashboard-card-follow-up"
            >
                <div class="el-card-title">
                    <!--                    <span>{{ $t('text.manage') }}</span>-->
                    {{ $t('navigation.followUp') }}
                </div>
            </router-link>
            <router-link
                v-if="
                    permissions.includes('SUPPLIER_VIEW') &&
                    selectedContainer.ContainerType !== 'CCC'
                "
                :to="{ name: 'supplier' }"
                class="el-dashboard-card el-dashboard-card-supplier"
            >
                <div class="el-card-title">
                    <span>{{ $t('text.manage') }}</span>
                    {{ $t('navigation.suppliers') }}
                </div>
            </router-link>
            <router-link
                v-if="
                    permissions.includes('SUPPLIER_VIEW') &&
                    selectedContainer.ContainerType &&
                    selectedContainer.ContainerType === 'CCC'
                "
                :to="{ name: 'supplier' }"
                class="el-dashboard-card el-dashboard-card-supplier"
            >
                <div class="el-card-title">
                    <!--                    <span>{{ $t('text.manage') }}</span>-->
                    {{ $t('navigation.supplierTool') }}
                </div>
            </router-link>
            <router-link
                v-if="
                    permissions.includes('VEHICLE_READ') &&
                    selectedContainer.ContainerType &&
                    selectedContainer.ContainerType === 'CCC'
                "
                :to="{ name: 'vehicleTool' }"
                class="el-dashboard-card el-dashboard-card-vehicleTool"
            >
                <div class="el-card-title">
                    <!--                    <span>{{ $t('text.manage') }}</span>-->
                    {{ $t('navigation.vehicleTool') }}
                </div>
            </router-link>
            <router-link
                v-if="
                    permissions.includes('USER_READ') &&
                    selectedContainer.ContainerType &&
                    selectedContainer.ContainerType === 'CCC'
                "
                :to="{ name: 'eventTool' }"
                class="el-dashboard-card el-dashboard-card-eventTool"
            >
                <div class="el-card-title">
                    <!--                    <span>{{ $t('text.manage') }}</span>-->
                    {{ $t('navigation.eventTool') }}
                </div>
            </router-link>
            <router-link
                v-if="
                    permissions.includes('USER_READ') &&
                    selectedContainer.ContainerType &&
                    selectedContainer.ContainerType === 'CCC'
                "
                :to="{ name: 'bookingOverviewTool' }"
                class="el-dashboard-card el-dashboard-card-bookingOverviewTool"
            >
                <div class="el-card-title">
                    <!--                    <span>{{ $t('text.manage') }}</span>-->
                    <span
                        style="font-size: 24px; display: block; width: 200px"
                        >{{ $t('navigation.bookingOverviewTool') }}</span
                    >
                </div>
            </router-link>
            <router-link
                v-if="permissions.includes('SCHEDULETEMPLATE_READ')"
                :to="{ name: 'global-schedule' }"
                class="el-dashboard-card el-dashboard-card-globalSchedule"
            >
                <div class="el-card-title">
                    <span>{{ $t('text.manage') }}</span>
                    <span
                        style="font-size: 24px; display: block; width: 200px"
                        >{{ $t('navigation.globalschedule') }}</span
                    >
                </div>
            </router-link>
            <router-link
                v-if="
                    permissions.includes('WAITINGAREA_READ') &&
                    selectedContainer &&
                    selectedContainer.ContainerType === 'CCC'
                "
                :to="{ name: 'waiting-areas' }"
                class="el-dashboard-card el-dashboard-card-waitingAreas"
            >
                <div class="el-card-title">
                    <span>{{ $t('text.manage') }}</span>
                    <span
                        style="font-size: 24px; display: block; width: 200px"
                        >{{ $t('navigation.waitingAreas') }}</span
                    >
                </div>
            </router-link>
            <router-link
                v-if="
                    permissions.includes('WAITINGAREA_READ') &&
                    selectedContainer &&
                    selectedContainer.ContainerType === 'CCC'
                "
                :to="{ name: 'checkpoint-tool' }"
                class="el-dashboard-card el-dashboard-card-waiting-area-tool"
            >
                <div class="el-card-title">
                    <!-- <span>{{ $t('text.manage') }}</span> -->
                    <span
                        style="font-size: 24px; display: block; width: 200px"
                        >{{ $t('navigation.waitingAreaTool') }}</span
                    >
                </div>
            </router-link>
            <router-link
                v-if="
                    selectedContainer &&
                    selectedContainer.ContainerType === 'CCC'
                "
                :to="{ name: 'inventory' }"
                class="el-dashboard-card el-dashboard-card-material-manager"
            >
                <div class="el-card-title">
                    <span>{{ $t('text.manage') }}</span>
                    <span
                        style="font-size: 24px; display: block; width: 200px"
                        >{{ $t('navigation.inventory') }}</span
                    >
                </div>
            </router-link>
        </el-row>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters(['isBlc', 'permissions', 'selectedContainer']),
    },
}
</script>
